import { loadAppStartupData } from 'App/Map/_utils/loadAppStartupData/loadAppStartupData'
import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { captureFrontendError } from 'utils/captureFrontendError'
import { AllDashboards } from './AllDashboards/AllDashboards'
import { DashboardFiltersProvider } from './_utils/dashboardFiltersContext'
import { useIsDashboardsSupported } from './_utils/useIsDashboardsSupported'
import { DASHBOARDS } from './dashboards'

export const DashboardsRoute = () => {
  const isSupported = useIsDashboardsSupported()

  // Populate fieldAssetStore / userDetailsStore / etc. when the user navigates
  // directly to /dashboards (the Map route normally does this on its own mount).
  // Skip on unsupported (phone) — we redirect to /map below, and Map loads it there.
  useEffect(() => {
    if (!isSupported) return

    loadAppStartupData().catch((err) => {
      captureFrontendError(err, { extra: { message: 'loadAppStartupData failed on /dashboards' } })
    })
  }, [isSupported])

  // Dashboards are desktop + iPad only — bounce phones that deep-link here back to the map.
  if (!isSupported) return <Navigate to="/map" replace />

  return (
    <DashboardFiltersProvider>
      <Routes>
        <Route path="/" element={<AllDashboards />} />
        {DASHBOARDS.map(({ id, Component }) => (
          <Route key={id} path={id} element={<Component />} />
        ))}
      </Routes>
    </DashboardFiltersProvider>
  )
}
